// src/components/auth/RequireAuth.tsx
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function RequireAuth() {
  const location = useLocation();

  // 1. 실제 인증 로직으로 교체해야 합니다. 
  // 예: 로컬 스토리지 토큰 확인, 혹은 Redux/Zustand 상태 확인
  // const isAuthenticated = !!localStorage.getItem("accessToken"); 
  
  // 임시: 토큰이 있다고 가정 (테스트 시 false로 바꿔보세요)
  const isAuthenticated = 
  !!localStorage.getItem("accessToken") || 
  !!sessionStorage.getItem("accessToken");

  if (!isAuthenticated) {
    const loginPath = location.pathname.startsWith('/master') ? '/master/login' : '/login';
    // 2. 로그인이 안되어 있다면 로그인 페이지로 리다이렉트
    // state={{ from: location }}을 넘겨주면 로그인 성공 후 원래 가려던 페이지로 돌아갈 수 있습니다.
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // 3. 로그인이 되어 있다면 자식 라우트(Outlet)를 보여줌
  return <Outlet />;
}
